<template>
  <div>
    <v-row v-if="loading">
      <v-col>
        <v-progress-circular indeterminate />
      </v-col>
    </v-row>

    <v-row v-else>
      <v-col cols="12">
        <v-card
          flat
          class="px-4 py-3"
          height="100%"
          :key="reRender"
          :class="!isEditCard1 ? 'mouse-cursor' : ''"
        >
          <div class="text-start">
            <v-row class="py-3">
              <v-col>
                <v-row>
                  <v-col
                    cols="5"
                    sm="4"
                    xl="3"
                    class="subtitle-1 textLight--text mouse-cursor"
                  >
                    <span>
                      {{
                        $t("user.profile.companyProfile.attendanceRevisionDate")
                      }}
                    </span>
                  </v-col>

                  <v-col
                    cols="7"
                    sm="8"
                    xl="9"
                    class="subtitle-1 textLight--text"
                    style="opacity: 0.5"
                  >
                    <Editable2
                      v-model="card1.attendanceRevisionDate"
                      :isEdit="isEditCard1"
                      ref="attendanceRevisionDate"
                    />
                  </v-col>
                </v-row>

                <v-divider class="my-3"></v-divider>

                <v-row>
                  <v-col
                    cols="5"
                    sm="4"
                    xl="3"
                    class="subtitle-1 textLight--text mouse-cursor"
                  >
                    <span>
                      {{
                        $t("user.profile.companyProfile.employeeMasterPassword")
                      }}
                    </span>
                  </v-col>

                  <v-col
                    cols="7"
                    sm="8"
                    xl="9"
                    class="subtitle-1 textLight--text"
                    style="opacity: 0.5"
                  >
                    <Editable2
                      v-model="card1.employeeMasterPassword"
                      :placeholder="passwordPlaceHolder"
                      :isEdit="isEditCard1"
                      ref="employeeMasterPassword"
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </div>

          <float-btn
            v-if="!loading"
            :isEdit="isEditCard1"
            @save="saveCard1Items"
            @edit="isEditCard1 = true"
            :bottom="true"
            :align="'right'"
            :loading="savingData1"
          />
        </v-card>
      </v-col>
    </v-row>

    <v-snackbar v-model="snackbarError" timeout="3000" color="error">
      {{ snackbarErrorMessage || $t("somethingWentWrong") }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="primary"
          text
          v-bind="attrs"
          @click="
            snackbarError = false;
            snackbarErrorMessage = null;
          "
        >
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import Editable2 from "../../../core-module/components/ContentEditable2.vue";
import FloatBtn from "../employee-profile/FloatBtn.vue";

import { createOrUpdateSubscriberProfile } from "../../methods/createOrUpdateSubscriberProfile";

export default {
  name: "CompanyProfileOtherSettings",
  components: {
    Editable2,
    FloatBtn,
  },
  props: {
    companyData: {
      type: Object,
      default: () => {},
      required: true,
    },
    loading: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      snackbarError: false,
      snackbarErrorMessage: null,
      card1: {
        attendanceRevisionDate: "",
        employeeMasterPassword: null,
      },
      companyProfile: null,
      savingData1: false,
      isEditCard1: false,
      reRender: 0,
      card1Error: {
        attendanceRevisionDateErr: null,
        employeeMasterPasswordErr: null,
      },
    };
  },
  computed: {
    passwordPlaceHolder() {
      return this.companyData?.employeeMasterPassword?.length
        ? "*****************"
        : "";
    },
  },
  watch: {
    companyData: {
      immediate: true,
      handler() {
        this.companyProfile = this.companyData ? this.companyData : null;
        this.resetFormData();
      },
      deep: true,
    },
  },
  methods: {
    resetCard1Error() {
      this.card1Error = {
        attendanceRevisionDateErr: null,
        employeeMasterPasswordErr: null,
      };
    },
    resetFormData() {
      this.card1.attendanceRevisionDate =
        this.companyProfile?.attendanceRevisionDate;
      this.card1.employeeMasterPassword = null;

      this.reRender++;
    },

    async saveCard1Items() {
      this.resetCard1Error();

      this.snackbarErrorMessage = null;

      this.card1Error.attendanceRevisionDateErr =
        (await this.$refs.attendanceRevisionDate.checkIsValid()) ? null : true;

      if (Object.values(this.card1Error).some(x => x != null)) {
        return;
      }

      this.savingData1 = true;
      this.isEditCard1 = false;

      let saveData = {
        attendanceRevisionDate: this.card1.attendanceRevisionDate
          ? this.card1.attendanceRevisionDate?.trim()
          : null,
        employeeMasterPassword: this.card1.employeeMasterPassword?.trim()
          ?.length
          ? this.card1.employeeMasterPassword?.trim()
          : null,
      };

      this.createOrUpdateProfile(saveData).then(response => {
        if (response.error) {
          this.$emit("onError");
          this.resetFormData();
        }

        this.savingData1 = false;
      });
    },

    createOrUpdateProfile(data) {
      return createOrUpdateSubscriberProfile(data);
    },
  },
};
</script>

<style scoped>
.hide-underline >>> .v-input__slot::before {
  border-style: none !important;
}
.hide-underline >>> .v-input__slot::after {
  border-style: none !important;
}
</style>
